import { Button, Col, Drawer, Pagination, Row, Image, Skeleton } from 'antd'
import './DrawerUpdates.style.less'
import {
  ArrowRightOutlined,
  DoubleRightOutlined,
  HistoryOutlined,
} from '@ant-design/icons'
import { convertUtcToLocalDateTime } from '@/utils/date'
import { convertToNumber, isEmptyValue, removeListPrefix } from '@/utils/common'
import { INSPECTION_SECTION_RESULT } from '@/constant/status'
import { useEffect, useState } from 'react'
import {
  find,
  get,
  includes,
  isArray,
  isObject,
  map,
  sortBy,
  startCase,
  times,
  toNumber,
  upperCase,
} from 'lodash'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { inspectionUpdatesRef } from '../../InSpectionReport.service'
import LOGO from '@/assets/images/icon.png'
import {
  DESIRED_ORDER_LOG,
  historyLogDrawer,
  INSPECTION_COMMENT_SECTION,
  INSPECTION_COMMENT_CHECKPOINT,
  UPDATE_TYPE,
  INSPECTION_COMMENT_NEEDS_REVISIONS,
  INSPECTION_COMMENT_SAMPLE_APPROVED,
  INSPECTION_COMMENT_INSPECTION_SUMMARY,
  INSPECTION_COMMENT_OVERALL,
  INSPECTION_COMMENT_UNDER_REVIEW,
  MEASUREMENT_SPECIAL_SEPARATOR_KEY,
} from '@/constant/qsf'

const {
  INSPECTION_CHECKPOINT_GROUP_ENTRY_UPDATE_PHOTO_COMMENT,
  INSPECTION_CHECKPOINT_DELETE_GROUP_ENTRY_UPDATE_PHOTO_COMMENT,
  INSPECTION_CHECKPOINT_ADD_GROUP_ENTRY_UPDATE_PHOTO_COMMENT,
  INSPECTION_CHECKPOINT_UPDATE_GROUP_ENTRY,
} = UPDATE_TYPE
import moment from 'moment'
import { DATE_FORMAT } from '@/constant/date'
const { defectPhotoDelete, defectPhotoAdd, defectPhotoComment } =
  historyLogDrawer

type CurrentPreviousType = {
  key: string
  previous: string
  current: string
}

interface Props {
  onClose: () => void
  open: boolean
  inspectionData: any
}

function DrawerUpdates(props: Props) {
  const { RESULT_OBJECT, DEFECT_CRITICALITY } = INSPECTION_SECTION_RESULT
  const color = (result) => {
    const classification = upperCase(result)
    return classification == RESULT_OBJECT.PASS
      ? '#65bf73'
      : [RESULT_OBJECT.FAIL].includes(classification)
      ? '#C03261'
      : [DEFECT_CRITICALITY.CRITICAL].includes(classification)
      ? '#C03261'
      : [RESULT_OBJECT.PENDING, RESULT_OBJECT.CIO].includes(classification)
      ? '#EF9747'
      : [DEFECT_CRITICALITY.MAJOR].includes(classification)
      ? '#EF9747'
      : [RESULT_OBJECT.PENDING].includes(classification)
      ? '#848484'
      : '#323232'
  }

  const isLongText = (value: string) => {
    return value?.length > 25
  }

  const params: any = useParams()

  const [page_number, setpage_number] = useState(1)
  const [mouseOver, setMouseOver] = useState(false)

  const { data, isLoading } = useQuery(
    ['UPDATES_HISTORY', page_number],
    async () => {
      return (await inspectionUpdatesRef(params?.key, { page_number }))?.data
    },
    {
      enabled: props.open,
    }
  )

  function SectionTitle({ item }: any) {
    let element = document.getElementById(item?.json_value?.extra?.section?.id)

    const scrollToView = () => {
      if (element) element.scrollIntoView({ behavior: 'smooth' })
    }
    const renderTitle = () => {
      let bulletPointSection = ''
      const sectionTitle = get(item, 'json_value.extra.section.title', '')
      const sectionName = get(item, 'json_value.extra.section.name', '')
      const getIndexes = item?.json_value?.extra?.indexes
      let getSectionDisplayOrder =
        item?.json_value?.extra?.section?.display_order

      // Note: parent.display_order starts at 1, not 0
      let getParentSectionDisplayOrder =
        item?.json_value?.extra?.section?.parent?.display_order

      if (getIndexes) {
        const cvSubSectionToNumber = convertToNumber(
          getIndexes?.subSectionIndex
        )
        const sectionIndexFromIndexes = getIndexes?.sectionIndex + 1
        const subSectionIndexFromIndexes = cvSubSectionToNumber + 1 || ''

        bulletPointSection = `${sectionIndexFromIndexes}.${subSectionIndexFromIndexes} `
      } else {
        getParentSectionDisplayOrder = Number.isFinite(
          getParentSectionDisplayOrder
        )
          ? getParentSectionDisplayOrder + '.'
          : ''
        getSectionDisplayOrder = Number.isFinite(getSectionDisplayOrder)
          ? getSectionDisplayOrder + 1
          : ''

        bulletPointSection = `${getParentSectionDisplayOrder}${getSectionDisplayOrder} `
      }
      const cvTitle = removeListPrefix(
        sectionTitle?.replace(MEASUREMENT_SPECIAL_SEPARATOR_KEY, ' ') ||
          startCase(
            sectionName?.replace(MEASUREMENT_SPECIAL_SEPARATOR_KEY, ' ')
          )
      )

      const replaceTitle = bulletPointSection + cvTitle
      const inspectionTitle = get(item, 'json_value.extra.inspection.title', '')
      const taskTitle = get(item, 'json_value.extra.task.title', '')

      if (inspectionTitle) {
        element = document.getElementById('inspection-summary-container')
      }

      return replaceTitle || taskTitle || inspectionTitle
    }

    if (
      includes(
        [INSPECTION_CHECKPOINT_ADD_GROUP_ENTRY_UPDATE_PHOTO_COMMENT],
        item?.type
      )
    ) {
      return (
        <>
          {' '}
          added a photo entry{' '}
          <b className="click-scroll-text" onClick={scrollToView}>
            {renderTitle()}
          </b>
        </>
      )
    }
    if (includes([INSPECTION_CHECKPOINT_UPDATE_GROUP_ENTRY], item?.type)) {
      return (
        <>
          {' '}
          edited an entry{' '}
          <b className="click-scroll-text" onClick={scrollToView}>
            {renderTitle()}
          </b>
        </>
      )
    }

    if (
      includes(
        [INSPECTION_CHECKPOINT_GROUP_ENTRY_UPDATE_PHOTO_COMMENT],
        item?.type
      )
    ) {
      return (
        <>
          {' '}
          edited a photo entry{' '}
          <b className="click-scroll-text" onClick={scrollToView}>
            {renderTitle()}
          </b>
        </>
      )
    }

    if (
      includes(
        [INSPECTION_CHECKPOINT_DELETE_GROUP_ENTRY_UPDATE_PHOTO_COMMENT],
        item?.type
      )
    ) {
      return (
        <>
          {' '}
          deleted a photo entry{' '}
          <b className="click-scroll-text" onClick={scrollToView}>
            {renderTitle()}
          </b>
        </>
      )
    }

    switch (item?.type) {
      case INSPECTION_COMMENT_CHECKPOINT:
      case INSPECTION_COMMENT_OVERALL:
      case INSPECTION_COMMENT_INSPECTION_SUMMARY:
      case INSPECTION_COMMENT_SECTION:
        return (
          <>
            {' '}
            commented{' '}
            <b className="click-scroll-text" onClick={scrollToView}>
              {renderTitle()}
            </b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_SECTION_UPDATE:
      case UPDATE_TYPE.INSPECTION_CHECKPOINT_SELECT:
      case UPDATE_TYPE.INSPECTION_CHECKPOINT_NUMBER:
      case UPDATE_TYPE.INSPECTION_CHECKPOINT_TEXT:
      case UPDATE_TYPE.INSPECTION_CHECKPOINT_DATE:
      case UPDATE_TYPE.INSPECTION_CHECKPOINT_MULTI_SELECT:
      case UPDATE_TYPE.INSPECTION_CHECKPOINT_EDITABLE_CHOICE:
        return (
          <>
            {' '}
            edited{' '}
            <b className="click-scroll-text" onClick={scrollToView}>
              {renderTitle()}
            </b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_DEFECT_DELETE:
        return (
          <>
            {' '}
            deleted a defect in{' '}
            <b className="click-scroll-text" onClick={scrollToView}>
              {renderTitle()}
            </b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_DEFECT_UPDATE:
        return (
          <>
            {' '}
            edited{' '}
            <b className="click-scroll-text" onClick={scrollToView}>
              {renderTitle()} Defects
            </b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_RESULT_UPDATE:
        return (
          <>
            {' '}
            edited <b>Inspection Conclusion</b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_CHECKPOINT_PHOTO_COMMENT:
        return (
          <>
            {' '}
            edited a comment in{' '}
            <b className="click-scroll-text" onClick={scrollToView}>
              {renderTitle()}
            </b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_CHECKPOINT_DELETE_PHOTO_COMMENT:
        return (
          <>
            {' '}
            deleted a photo in{' '}
            <b className="click-scroll-text" onClick={scrollToView}>
              {renderTitle()}
            </b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_CHECKPOINT_ADD_PHOTO_COMMENT:
        return (
          <>
            {' '}
            added a photo in{' '}
            <b className="click-scroll-text" onClick={scrollToView}>
              {renderTitle()}
            </b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_DECISION_UPDATE:
        return (
          <>
            {' '}
            edited <b>Inspection Decision</b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_SUBMIT:
        return (
          <>
            {' '}
            submitted <b>{`Inspection no. ${props?.inspectionData?.number}`}</b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_APPROVE:
        return (
          <>
            {' '}
            approved the report of{' '}
            <b>Inspection no. {props?.inspectionData?.number}</b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_UNLOCK_APPROVED:
        return (
          <>
            {' '}
            unlocked the report of{' '}
            <b>Inspection no. {props?.inspectionData?.number}</b>
          </>
        )
      case UPDATE_TYPE.INSPECTION_DELETE_APPROVED:
        return (
          <>
            {' '}
            deleted <b>Inspection no. {props?.inspectionData?.number}</b>
          </>
        )
      case INSPECTION_COMMENT_NEEDS_REVISIONS:
        return (
          <>
            {' '}
            request revisions for{' '}
            <b>Inspection no. {props?.inspectionData?.number}</b>
          </>
        )
      case INSPECTION_COMMENT_UNDER_REVIEW:
        return (
          <>
            {' '}
            submitted <b>Inspection no. {props?.inspectionData?.number}</b> for
            review
          </>
        )
      case INSPECTION_COMMENT_SAMPLE_APPROVED:
        return (
          <>
            {' '}
            approve sample the report of{' '}
            <b>Inspection no. {props?.inspectionData?.number}</b>
          </>
        )

      case UPDATE_TYPE.INSPECTION_DEFECT_PHOTO_COMMENT:
        return (
          <span>
            <p>{defectPhotoComment}</p>
            <b className="click-scroll-text" onClick={scrollToView}>
              {renderTitle()} Defects
            </b>
          </span>
        )
      // TODO History check defect
      case UPDATE_TYPE.INSPECTION_DEFECT_PHOTO_ADD:
        return (
          <span>
            <p>{defectPhotoAdd}</p>
            <b className="click-scroll-text" onClick={scrollToView}>
              {renderTitle()} Defects
            </b>
          </span>
        )
      case UPDATE_TYPE.INSPECTION_DEFECT_PHOTO_DELETE:
        return (
          <span>
            <p>{defectPhotoDelete}</p>
            <p>
              <b className="click-scroll-text" onClick={scrollToView}>
                {renderTitle()} Defects
              </b>
            </p>
          </span>
        )
      default:
        return <></>
    }
  }

  const transformArray = (arrays: string[]) => {
    const result = sortBy(arrays, (item) => DESIRED_ORDER_LOG.indexOf(item))
    return result
  }

  function UpdateContent({ item }: any) {
    // Exclude render comments
    if (
      [
        INSPECTION_COMMENT_NEEDS_REVISIONS,
        INSPECTION_COMMENT_UNDER_REVIEW,
        INSPECTION_COMMENT_SAMPLE_APPROVED,
        UPDATE_TYPE.INSPECTION_DELETE_APPROVED,
        UPDATE_TYPE.INSPECTION_UNLOCK_APPROVED,
      ].includes(item.type)
    ) {
      return <></>
    }

    const difference = [...item?.json_value?.differences]
    const valueToMap: CurrentPreviousType[] = []
    const swapDifferentOrder = transformArray(difference)

    swapDifferentOrder?.forEach((keyDifferent) => {
      let tmpPrevious = item?.json_value?.previous[keyDifferent]
      let tmpCurrent = item?.json_value?.current[keyDifferent]

      // Noted: sample of current and previous can be
      // [{label: "Red", value: "Red"}, {label: "Blue", value: "Blue"}]
      // {label: "Red", value: "Red"}
      // ['Red', 'Blue']
      // 'Red'
      if (isArray(tmpCurrent) || isArray(tmpPrevious)) {
        tmpCurrent = map(tmpCurrent, (i: any) => (i.label ? i.label : i))
        tmpPrevious = map(tmpPrevious, (i: any) => (i.label ? i.label : i))
        keyDifferent = ''
      }

      if (isObject(tmpCurrent)) {
        if (includes(['json_value'], keyDifferent)) {
          keyDifferent = ''
        }

        const groupImagePrevious = find(tmpPrevious, (item) =>
          get(item, 'originalId')
        )
        const groupImageCurrent = find(tmpCurrent, (item) =>
          get(item, 'originalId')
        )

        if (groupImageCurrent) {
          // TODO Just verify group image later after AIP done
        } else {
          let joinStringCurrent = map(tmpCurrent, (i) => i).join(', ')
          let joinStringPrevious = map(tmpPrevious, (i) => i).join(', ')

          if (!isArray(tmpPrevious)) {
            joinStringPrevious = get(tmpPrevious, 'value', '')
          }
          if (!isArray(tmpCurrent)) {
            joinStringCurrent = get(tmpCurrent, 'value', '')
          }
          valueToMap.push({
            key: keyDifferent,
            previous: joinStringPrevious,
            current: joinStringCurrent,
          })
        }
      } else {
        let wrapValuePrevious = tmpPrevious
        let wrapValueCurrent = tmpCurrent

        // tmpCurrent and tmpPrevious can be number or date string
        // '1234' or '2025-09-11T04:22:00.000Z'
        if (!Number(tmpCurrent)) {
          const isCurrentTypeDate = moment
            .utc(tmpCurrent, moment.ISO_8601, true)
            .isValid()
          if (isCurrentTypeDate) {
            wrapValueCurrent =
              moment(tmpCurrent).format(DATE_FORMAT.DDMMYY) ?? null
          }
        }

        if (!Number(tmpPrevious)) {
          const isPreviousTypeDate = moment
            .utc(tmpPrevious, moment.ISO_8601, true)
            .isValid()
          if (isPreviousTypeDate) {
            wrapValuePrevious =
              moment(tmpPrevious).format(DATE_FORMAT.DDMMYY) ?? null
          }
        }

        if (includes(['json_value'], keyDifferent)) {
          keyDifferent = ''
        }

        valueToMap.push({
          key: keyDifferent,
          previous: wrapValuePrevious ?? null,
          current: wrapValueCurrent ?? null,
        })
      }
    })

    const { json_value } = item
    const { defect, name, index: entryIndex } = json_value.extra
    const defectCode = defect?.code || ''
    const defectName = defect?.name || ''
    const isActivitiesTypeInspectionSFR = includes(
      [
        INSPECTION_COMMENT_SECTION,
        INSPECTION_COMMENT_CHECKPOINT,
        INSPECTION_COMMENT_NEEDS_REVISIONS,
        INSPECTION_COMMENT_UNDER_REVIEW,
        INSPECTION_COMMENT_OVERALL,
        INSPECTION_COMMENT_INSPECTION_SUMMARY,
        INSPECTION_COMMENT_SAMPLE_APPROVED,
      ],
      item.type
    )

    const combineDefectSectionName = [defectCode, defectName]
      .filter(Boolean)
      .join(' - ')
    const [showComment, setShowComment] = useState(false)
    const onShowComment = () => {
      setShowComment(!showComment)
    }

    const valueKey = {
      photo: 'photo',
    }

    const handleRenderOther = (otherValue: CurrentPreviousType) => {
      const { previous = '', current = '' } = otherValue
      const oldValueLineThrough = previous ? 'text-decoration-line' : ''
      const isPreviousNotIncludeType = ![
        UPDATE_TYPE.INSPECTION_CHECKPOINT_ADD_PHOTO_COMMENT,
        UPDATE_TYPE.INSPECTION_DEFECT_PHOTO_ADD,
      ].includes(item.type)
      const isCurrentNotIncludeType = ![
        UPDATE_TYPE.INSPECTION_CHECKPOINT_DELETE_PHOTO_COMMENT,
        UPDATE_TYPE.INSPECTION_DEFECT_PHOTO_DELETE,
      ].includes(item.type)
      let displayPrevious = previous
      let displayCurrent = current

      const displayOverflowText =
        !showComment && !isActivitiesTypeInspectionSFR ? 'overflow-text' : ''

      if (isPreviousNotIncludeType && !previous) {
        displayPrevious = 'Empty'
      }

      if (isCurrentNotIncludeType && !current) {
        displayCurrent = 'Empty'
      }

      if (isActivitiesTypeInspectionSFR) {
        displayPrevious = ''
      }

      return (
        <>
          <p
            className={`old-value ${oldValueLineThrough} ${
              !showComment ? 'overflow-text' : ''
            } `}
          >
            {displayPrevious}
          </p>
          {![
            UPDATE_TYPE.INSPECTION_DEFECT_DELETE,
            UPDATE_TYPE.INSPECTION_CHECKPOINT_ADD_PHOTO_COMMENT,
            UPDATE_TYPE.INSPECTION_DEFECT_PHOTO_ADD,
            UPDATE_TYPE.INSPECTION_CHECKPOINT_DELETE_PHOTO_COMMENT,
            UPDATE_TYPE.INSPECTION_DEFECT_PHOTO_DELETE,
          ].includes(item.type) &&
            !isActivitiesTypeInspectionSFR && (
              <ArrowRightOutlined className="arrow-change" />
            )}
          <p
            className={`new-value ${displayOverflowText}`}
            style={{
              color: color(current),
            }}
          >
            {displayCurrent}
          </p>
        </>
      )
    }

    const handleRenderPhoto = (val) => {
      return (
        <>
          {!isEmptyValue(val?.previous) && <Image src={val?.previous} />}

          {![
            UPDATE_TYPE.INSPECTION_DEFECT_DELETE,
            UPDATE_TYPE.INSPECTION_CHECKPOINT_ADD_PHOTO_COMMENT,
            UPDATE_TYPE.INSPECTION_DEFECT_PHOTO_ADD,
          ].includes(item.type) && (
            <ArrowRightOutlined className="arrow-change" />
          )}
          {isEmptyValue(val?.current) && (
            <p
              className={
                [
                  UPDATE_TYPE.INSPECTION_CHECKPOINT_DELETE_PHOTO_COMMENT,
                  UPDATE_TYPE.INSPECTION_DEFECT_PHOTO_DELETE,
                ].includes(item.type)
                  ? 'old-value-deleted'
                  : 'old-value text-decoration-line'
              }
            >
              {[
                UPDATE_TYPE.INSPECTION_CHECKPOINT_DELETE_PHOTO_COMMENT,
                UPDATE_TYPE.INSPECTION_DEFECT_PHOTO_DELETE,
              ].includes(item.type)
                ? 'Deleted'
                : 'Empty'}
            </p>
          )}
          {!isEmptyValue(val?.current) && <Image src={val?.current} />}
        </>
      )
    }

    const handleRenderHistoryByKey = (value, index) => {
      const { key } = value
      if (key !== valueKey.photo) {
        return handleRenderOther(value) // tmp disable to prevent error when updated Group Entry
      } else {
        return handleRenderPhoto(value)
      }
    }

    if (isEmptyValue(difference)) return <></>

    if (item?.type == UPDATE_TYPE.INSPECTION_APPROVE) return <></>

    const entryLabel =
      entryIndex !== undefined ? (
        <p className="content-entry-label">Entry #{toNumber(entryIndex) + 1}</p>
      ) : (
        <></>
      )
    const nameTag = !isActivitiesTypeInspectionSFR && (
      <p
        className="content-label"
        style={{ marginBottom: '15px', fontSize: '14px' }}
      >
        {startCase(name)}
      </p>
    )

    return (
      <div className="updates-content">
        {entryLabel}
        {combineDefectSectionName && (
          <p className="card-title">
            <b>{combineDefectSectionName}</b>
          </p>
        )}

        {nameTag}

        {valueToMap?.map((val, key) => {
          let displayReadMore =
            val?.key == 'photo' ||
            ((isLongText(val?.current) || isLongText(val?.previous)) && (
              <Button
                className="readmore-button"
                size="small"
                type="text"
                onClick={onShowComment}
              >
                {showComment ? 'Read Less' : 'Read More'}
              </Button>
            ))

          let labelContent = (
            <p className="content-label">{startCase(val?.key)}</p>
          )

          if (isActivitiesTypeInspectionSFR) {
            labelContent = null
            displayReadMore = null
          }

          return (
            <div key={key}>
              {labelContent}
              <Row align={'middle'}>{handleRenderHistoryByKey(val, key)}</Row>
              {displayReadMore}
              {valueToMap?.length - 1 != key && (
                <div className="fake-padding" />
              )}
            </div>
          )
        })}
      </div>
    )
  }

  const onClose = () => {
    setpage_number(1)

    props.onClose()
    document.body.querySelector('.ant-drawer-body').scrollTo(0, 0)
  }

  useEffect(() => {
    const isOpenSelect = document.querySelector('.ant-select-open')
    const allowScrolling = !mouseOver && !isOpenSelect
    if (allowScrolling) {
      document.body.style.overflow = 'auto'
    } else {
      document.body.style.overflow = ''
    }
  }, [mouseOver])

  if (isLoading) {
    return (
      <Drawer
        title=""
        placement={'right'}
        closable={false}
        open={props.open}
        key={'right'}
        width={400}
      >
        <div className="drawer-updates-container">
          <div className="sticky-position">
            <Button
              onClick={onClose}
              className="button-close"
              icon={<DoubleRightOutlined className="close-icon" />}
            />
            <Row align={'middle'} className="title-container">
              <HistoryOutlined /> <p>History</p>
            </Row>
            {map(times(4), () => (
              <Skeleton avatar paragraph={{ rows: 5 }} />
            ))}
          </div>
        </div>
      </Drawer>
    )
  }

  return (
    <Drawer
      title=""
      placement={'right'}
      closable={false}
      open={props.open}
      key={'right'}
      width={400}
      onMouseOver={() => {
        setMouseOver(true)
      }}
      onMouseLeave={() => setMouseOver(false)}
    >
      <div className="drawer-updates-container">
        <div className="sticky-position">
          <Button
            onClick={onClose}
            className="button-close"
            icon={<DoubleRightOutlined className="close-icon" />}
          />
          <Row align={'middle'} className="title-container">
            <HistoryOutlined /> <p>History</p>
          </Row>
        </div>
        <div className="fake-height" />
        {data?.data?.map((item, index) => {
          const fullName = `${item?.created_by?.first_name} ${item?.created_by?.last_name}`
          return (
            <div key={index} className="updates-item-container">
              <Row>
                <Col span={3}>
                  <Image
                    loading="lazy"
                    src={item?.created_by?.avatar?.url_path ?? ''}
                    fallback={LOGO}
                    preview={false}
                    alt="Profile"
                    className="img-user"
                  />
                </Col>
                <Col span={21}>
                  <p className="updates-title">
                    <b>{fullName}</b>
                    <SectionTitle item={item} />
                  </p>
                  <UpdateContent item={item} index={index} />
                  <p className="date-label">
                    {convertUtcToLocalDateTime(item?.created_date)}
                  </p>
                </Col>
              </Row>
            </div>
          )
        })}
        <div className="fake-footer" />
        <div className="pagination">
          <Pagination
            onChange={(page) => setpage_number(page)}
            current={page_number}
            pageSize={10}
            total={data?.pagination?.total_record}
          />
        </div>
      </div>
    </Drawer>
  )
}

export default DrawerUpdates
